import { create } from "zustand";

type View = "list" | "edit" | "detail";

type State = {
  isOpen: boolean;
  currentView: "list" | "edit" | "detail";
  selectedMemoId: string | null;
  isLoading: boolean;
  openChatMemo: () => void;
  closeChatMemo: () => void;
  toggleChatMemo: () => void;
  setIsLoading: (isLoading: boolean) => void;
  setCurrentView: (currentView: "list" | "edit" | "detail") => void;
  setSelectedMemoId: (selectedMemoId: string | null) => void;
};

const useChatMemoStore = create<State>((set) => ({
  isOpen: false,
  isLoading: false,
  currentView: "list",
  selectedMemoId: null,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setCurrentView: (currentView: View) => set({ currentView }),
  setSelectedMemoId: (selectedMemoId: string | null) => set({ selectedMemoId }),
  openChatMemo: () => set({ isOpen: true }),
  closeChatMemo: () => set({ isOpen: false }),
  toggleChatMemo: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default useChatMemoStore;
